// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__2y1ns","Logo":"Navbar_Logo__19luv","DesktopOnly":"Navbar_DesktopOnly__iPguU"};